import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createConstructionSiteUsageStatisticEntityInfo } from 'record-it-time-common/entity/entities/ConstructionSiteUsageStatistic/createConstructionSiteUsageStatisticEntityInfo';
import { ConstructionSiteUsageStatistic } from './constructionSiteUsageStatisticTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export const constructionSiteUsageStatisticEntityInfo =
  createConstructionSiteUsageStatisticEntityInfo<ConstructionSiteUsageStatistic>(
    {
      additionalFieldInfos:
        EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
    }
  );
